import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

const  AlertDialog = ({handleAccept, handleClose, text, open, isLoading}) =>  {
    console.log(isLoading);
    console.log(open);
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {text}
                </DialogTitle>
                <DialogActions>
                    <Button className='buttonOhs' onClick={handleClose} aria-label={"Fermer"}>Non</Button>
                    <Button className='buttonOhs' onClick={() => {if (!isLoading) handleAccept()}} autoFocus aria-label={"Accepter"}>
                        {isLoading ? <CircularProgress color="inherit" size={30}/> : 'Oui'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AlertDialog;
